import { ajax } from '@/api'

export default {
    /**
     * 查询列表
     */
    queryota  ( data ) {
        const url = "/ota/queryota"
        return ajax({ url, data, method: 'post' })
    },
	
    /**
     * 编辑
     */
    saveota ( data ) {
        const url = '/ota/saveota'

        return ajax({ url, data, method: 'post' })
    },
  deleteota ( data ) {
    const url = '/ota/deleteota'
    return ajax({ url, data, method: 'post' })
  },
  /**
   * 获取cdntoken
   */
  getCdnToken  ( data ) {
    const url = "/user/getcdntoken"
    return ajax({ url, data, method: 'post' })
  },
}
